import type { AccountKey, MailboxType } from 'owa-client-types';

export const CACHE_KEY_PREFIX: string = 'cacheKey_';
export const GLOBAL_ACCOUNT_CACHE_KEY: string = `${CACHE_KEY_PREFIX}globalAccount`;

export interface MailboxCollectorAccountInfo {
    isGlobalAccount: boolean;
    multiAccountType: 'GlobalAccount' | 'SecondaryAccount';
    mailboxType: MailboxType | undefined;
}

export interface MailboxCollectorUrlMapping {
    accountKey: AccountKey | 'globalAccount';
    collectorUrl: string;
    multiAccountType: 'GlobalAccount' | 'SecondaryAccount';
    mailboxType: MailboxType | undefined;
}

export interface MailboxAccountInfoMappingAddon {
    getCollectorUrlForMailbox: (accountKey: AccountKey | 'globalAccount') => string | undefined;
    getMappedMailboxAccountInfo: (
        accountKey: AccountKey | 'globalAccount'
    ) => MailboxCollectorAccountInfo | undefined;
    getMailboxCacheKey: (
        accountKey: AccountKey | 'globalAccount' | undefined,
        scenario: string
    ) => string;
    setMailboxCollectorUrlMapping: (
        accountKey: AccountKey | 'globalAccount',
        collectorUrl: string,
        multiAccountType: 'GlobalAccount' | 'SecondaryAccount',
        mailboxType: MailboxType | undefined,
        alternateAccountKey?: AccountKey
    ) => void;
    syncAllMailboxAccountInfoMappings: () => void;
    getAllMailboxCollectorUrlMappings: () => MailboxCollectorUrlMapping[];
}
